import { useEffect } from 'react';
import { useState } from 'react';
import { useDebounce } from 'use-debounce';
import { useRouterLoading } from '../../_hooks/useRouterLoading';

/**
 * Индикатор загрузки.
 * Принимает значение `true` если есть отложенное изменившееся состояние (isStatePending возвращает `true`),
 * либо если роутер находится в состоянии обновления.
 */
export const useLoadingIndicator = (
    isStatePending: () => boolean,
    deps: any[]
) => {
    const [isLoading, setLoading] = useState(false);

    const isRouterLoading = useRouterLoading();

    useEffect(() => {
        if (isStatePending() || isRouterLoading) {
            setLoading(true);
        } else {
            setLoading(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoading, isStatePending, isRouterLoading, ...deps]);

    /*
     * Возвращаем отложенное на 200мс состояние перехода true -> false, чтобы предотвратить моргание
     */
    const [debouncedIsLoading] = useDebounce(isLoading, 200, {
        leading: false,
        trailing: true,
    });

    return isLoading || debouncedIsLoading;
};
